import { FC } from 'react';

import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';

import { Casinos } from './casinos/Casinos';
import { CasinoSettingsTab } from './constants';
import { CreateCasinoButton } from './createCasinoButton/CreateCasinoButton';
import { CreatePartnerSpotlightButton } from './createPartnerSpotlightButton/CreatePartnerSpotlightButton';
import { PartnerSpotlights } from './partnerSpotlights/PartnerSpotlights';

import css from './CasinoSettingsPage.module.css';

import { PageLayout } from 'v2/components/pageLayout/PageLayout';
import { PageTitle } from 'v2/components/pageLayout/pageTitle/PageTitle';
import { useTabs } from 'v2/hooks/useTabs';

export const CasinoSettingsPage: FC = () => {
  const { activeTab, onTabChange } = useTabs<CasinoSettingsTab>(CasinoSettingsTab.CASINOS);

  return (
    <PageLayout className={css.casinoSettingsPage} overflow="hidden">
      <PageTitle
        action={activeTab === CasinoSettingsTab.CASINOS ? <CreateCasinoButton /> : <CreatePartnerSpotlightButton />}
      >
        Casino Settings
      </PageTitle>

      <Tabs value={activeTab} onChange={(_, v) => onTabChange(v)}>
        <Tab value={CasinoSettingsTab.CASINOS} label="Casinos" />
        <Tab value={CasinoSettingsTab.PARTNER_SPOTLIGHTS} label="Partner Spotlights" />
      </Tabs>

      <div className={css.casinoSettingsPageContent}>
        {activeTab === CasinoSettingsTab.CASINOS && <Casinos />}
        {activeTab === CasinoSettingsTab.PARTNER_SPOTLIGHTS && <PartnerSpotlights />}
      </div>
    </PageLayout>
  );
};
